export default class DtoExploitationCodification {
    constructor(object) {
        this.idExploitation = object.idExploitation // Long,
        this.startDate = object.startDate // Option[DateTime],
        this.endDate = object.endDate // Option[DateTime],
        this.codificationType = object.codificationType // Option[Long],
        this.codification = object.codification // Option[String]
    }
}